import { useState } from "react";
import { Siren } from "lucide-react";
import { useEmergencies, relevantProtocols } from "../../lib/emergencies";
import { ProtocolList } from "./ProtocolList";

export function CaseEmergencies({ recs }) {
  const data = useEmergencies();
  const [open, setOpen] = useState("");
  if (!data || !recs?.length) return null;
  const items = recs.filter((r) => !r.item_id.startsWith("proc_"));
  const protos = relevantProtocols(data, items.map((r) => r.item_id));
  const names = Object.fromEntries(items.map((r) => [r.item_id, r.item_name]));
  const forLabel = (p) => {
    const ids = items.filter((r) => (data.item_map[r.item_id] || []).includes(p.id)).map((r) => names[r.item_id]);
    return ids.length ? `for ${ids.join(", ")}` : "always be ready";
  };
  return (
    <section className="mt-5 rounded-2xl border-2 border-red-500 bg-red-50/50 overflow-hidden" data-testid="case-emergencies">
      <div className="px-5 py-3 bg-red-600 text-white">
        <p className="font-heading font-bold flex items-center gap-2"><Siren className="w-5 h-5" /> If a medical emergency happens with this patient</p>
        <p className="text-xs text-red-50 mt-0.5">Protocols matched to this patient's conditions & medications · Resuscitation Council UK · ERC 2025 · AHA 2025 · BNF</p>
      </div>
      <div className="p-4"><ProtocolList protocols={protos} open={open} onOpen={setOpen} forLabel={forLabel} /></div>
    </section>
  );
}
